import { render, staticRenderFns } from "./webPage.vue?vue&type=template&id=4d189e54&"
import script from "./webPage.vue?vue&type=script&lang=js&"
export * from "./webPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports